// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timepicker {
  position: absolute;
  top: 100%;
  left: 0;
  width: 140px;
  background-color: rgb(255, 255, 255);
  z-index: 10;
  border: 1px solid #dee2e6;
  margin-top: -1px;
}
.timepicker .hour {
  overflow: auto;
  height: 150px;
  flex: 1 1;
  border-right: 1px solid #dee2e6;
}
.timepicker .hour:nth-last-child(1) {
  border-right: none;
}
.timepicker .hour > div {
  padding: 5px 10px;
  text-align: center;
  cursor: pointer;
}
.timepicker .hour > div:hover {
  background: #3bafda;
  color: #fff;
}
.timepicker .hour > div.active {
  background: #3bafda;
  color: #fff;
}
.timepicker .wrap {
  display: flex;
}

.timeBox {
  position: relative;
}

.selectBtn {
  font-weight: bold;
  border-top: 1px solid #dee2e6;
  text-align: center;
  padding: 5px 10px;
  cursor: pointer;
}

`, "",{"version":3,"sources":["webpack://./src/components/TimePicker/TimePicker.module.scss","webpack://./src/components/TimePicker/TimePicker.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,oCAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;ACCF;ADCE;EACE,cAAA;EACA,aAAA;EACA,SAAA;EACA,+BAAA;ACCJ;ADCI;EACE,kBAAA;ACCN;ADEI;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;ACAN;ADEM;EACE,mBAAA;EACA,WAAA;ACAR;ADGM;EACE,mBAAA;EACA,WAAA;ACDR;ADME;EACE,aAAA;ACJJ;;ADQA;EACE,kBAAA;ACLF;;ADQA;EACE,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;ACLF","sourcesContent":[".timepicker {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 140px;\n  background-color: rgba(255, 255, 255, 1);\n  z-index: 10;\n  border: 1px solid #dee2e6;\n  margin-top: -1px;\n\n  .hour {\n    overflow: auto;\n    height: 150px;\n    flex: 1;\n    border-right: 1px solid #dee2e6;\n\n    &:nth-last-child(1) {\n      border-right: none;\n    }\n\n    &>div {\n      padding: 5px 10px;\n      text-align: center;\n      cursor: pointer;\n\n      &:hover {\n        background: #3bafda;\n        color: #fff;\n      }\n\n      &.active {\n        background: #3bafda;\n        color: #fff;\n      }\n    }\n  }\n\n  .wrap {\n    display: flex;\n  }\n}\n\n.timeBox {\n  position: relative;\n}\n\n.selectBtn {\n  font-weight: bold;\n  border-top: 1px solid #dee2e6;\n  text-align: center;\n  padding: 5px 10px;\n  cursor: pointer;\n}\n",".timepicker {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 140px;\n  background-color: rgb(255, 255, 255);\n  z-index: 10;\n  border: 1px solid #dee2e6;\n  margin-top: -1px;\n}\n.timepicker .hour {\n  overflow: auto;\n  height: 150px;\n  flex: 1;\n  border-right: 1px solid #dee2e6;\n}\n.timepicker .hour:nth-last-child(1) {\n  border-right: none;\n}\n.timepicker .hour > div {\n  padding: 5px 10px;\n  text-align: center;\n  cursor: pointer;\n}\n.timepicker .hour > div:hover {\n  background: #3bafda;\n  color: #fff;\n}\n.timepicker .hour > div.active {\n  background: #3bafda;\n  color: #fff;\n}\n.timepicker .wrap {\n  display: flex;\n}\n\n.timeBox {\n  position: relative;\n}\n\n.selectBtn {\n  font-weight: bold;\n  border-top: 1px solid #dee2e6;\n  text-align: center;\n  padding: 5px 10px;\n  cursor: pointer;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
